import { Styles } from "@mcleod/core";

export const ListStyles = Styles.make("list", {
    root: {
        outline: "none"
    }
});
